var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.05566 4.04848C3.05566 4.31185 3.16029 4.56444 3.34652 4.75067C3.53276 4.93691 3.78534 5.04153 4.04872 5.04153C4.31209 5.04153 4.56468 4.93691 4.75092 4.75067C4.93715 4.56444 5.04178 4.31185 5.04178 4.04848C5.04178 3.7851 4.93715 3.53251 4.75092 3.34628C4.56468 3.16005 4.31209 3.05542 4.04872 3.05542C3.78534 3.05542 3.53276 3.16005 3.34652 3.34628C3.16029 3.53251 3.05566 3.7851 3.05566 4.04848Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0068 4.04848C10.0068 4.31185 10.1115 4.56444 10.2977 4.75067C10.4839 4.93691 10.7365 5.04153 10.9999 5.04153C11.2633 5.04153 11.5159 4.93691 11.7021 4.75067C11.8883 4.56444 11.9929 4.31185 11.9929 4.04848C11.9929 3.7851 11.8883 3.53251 11.7021 3.34628C11.5159 3.16005 11.2633 3.05542 10.9999 3.05542C10.7365 3.05542 10.4839 3.16005 10.2977 3.34628C10.1115 3.53251 10.0068 3.7851 10.0068 4.04848Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.958 4.04872C16.958 4.31209 17.0626 4.56468 17.2489 4.75092C17.4351 4.93715 17.6877 5.04178 17.9511 5.04178C18.2144 5.04178 18.467 4.93715 18.6533 4.75092C18.8395 4.56468 18.9441 4.31209 18.9441 4.04872C18.9441 3.78534 18.8395 3.53276 18.6533 3.34652C18.467 3.16029 18.2144 3.05566 17.9511 3.05566C17.6877 3.05566 17.4351 3.16029 17.2489 3.34652C17.0626 3.53276 16.958 3.78534 16.958 4.04872Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.05566 11.0001C3.05566 11.2635 3.16029 11.5161 3.34652 11.7023C3.53276 11.8886 3.78534 11.9932 4.04872 11.9932C4.31209 11.9932 4.56468 11.8886 4.75092 11.7023C4.93715 11.5161 5.04178 11.2635 5.04178 11.0001C5.04178 10.7368 4.93715 10.4842 4.75092 10.2979C4.56468 10.1117 4.31209 10.0071 4.04872 10.0071C3.78534 10.0071 3.53276 10.1117 3.34652 10.2979C3.16029 10.4842 3.05566 10.7368 3.05566 11.0001Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.0068 11.0001C10.0068 11.2635 10.1115 11.5161 10.2977 11.7023C10.4839 11.8886 10.7365 11.9932 10.9999 11.9932C11.2633 11.9932 11.5159 11.8886 11.7021 11.7023C11.8883 11.5161 11.9929 11.2635 11.9929 11.0001C11.9929 10.7368 11.8883 10.4842 11.7021 10.2979C11.5159 10.1117 11.2633 10.0071 10.9999 10.0071C10.7365 10.0071 10.4839 10.1117 10.2977 10.2979C10.1115 10.4842 10.0068 10.7368 10.0068 11.0001Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.958 10.9999C16.958 11.2633 17.0626 11.5159 17.2489 11.7021C17.4351 11.8883 17.6877 11.9929 17.9511 11.9929C18.2144 11.9929 18.467 11.8883 18.6533 11.7021C18.8395 11.5159 18.9441 11.2633 18.9441 10.9999C18.9441 10.7365 18.8395 10.4839 18.6533 10.2977C18.467 10.1115 18.2144 10.0068 17.9511 10.0068C17.6877 10.0068 17.4351 10.1115 17.2489 10.2977C17.0626 10.4839 16.958 10.7365 16.958 10.9999Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.05566 17.9513C3.05566 18.2147 3.16029 18.4673 3.34652 18.6535C3.53276 18.8397 3.78534 18.9444 4.04872 18.9444C4.31209 18.9444 4.56468 18.8397 4.75092 18.6535C4.93715 18.4673 5.04178 18.2147 5.04178 17.9513C5.04178 17.6879 4.93715 17.4353 4.75092 17.2491C4.56468 17.0629 4.31209 16.9583 4.04872 16.9583C3.78534 16.9583 3.53276 17.0629 3.34652 17.2491C3.16029 17.4353 3.05566 17.6879 3.05566 17.9513Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.0068 17.9513C10.0068 18.2147 10.1115 18.4673 10.2977 18.6535C10.4839 18.8397 10.7365 18.9444 10.9999 18.9444C11.2633 18.9444 11.5159 18.8397 11.7021 18.6535C11.8883 18.4673 11.9929 18.2147 11.9929 17.9513C11.9929 17.6879 11.8883 17.4353 11.7021 17.2491C11.5159 17.0629 11.2633 16.9583 10.9999 16.9583C10.7365 16.9583 10.4839 17.0629 10.2977 17.2491C10.1115 17.4353 10.0068 17.6879 10.0068 17.9513Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.958 17.9511C16.958 18.2144 17.0626 18.467 17.2489 18.6533C17.4351 18.8395 17.6877 18.9441 17.9511 18.9441C18.2144 18.9441 18.467 18.8395 18.6533 18.6533C18.8395 18.467 18.9441 18.2144 18.9441 17.9511C18.9441 17.6877 18.8395 17.4351 18.6533 17.2489C18.467 17.0626 18.2144 16.958 17.9511 16.958C17.6877 16.958 17.4351 17.0626 17.2489 17.2489C17.0626 17.4351 16.958 17.6877 16.958 17.9511Z",
    fill: "#5E5E5E",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.2172f4aa50d0bd527b5fc25d4f0ca573.svg";
export { ForwardRef as ReactComponent };